import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  AppBar,
  Toolbar,
  makeStyles,
} from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  panelHeader: {
    backgroundColor: theme.palette.primary.background,
    color: theme.palette.secondary.main,
  },
  cardTitle: {
    color: theme.palette.darkGrey.main,
    fontWeight: 600,
  },
}))

const Panel = (props) => {
  const classes = useStyles()
  const { children, startText, endView, CardContentProps, AppBarProps } = props

  return (
    <div>
      <Card elevation={1} className="flex-auto">
        <AppBar
          position="static"
          elevation={0}
          className={clsx(classes.panelHeader, 'border-b-1 border-solid')}
          {...AppBarProps}
        >
          <Toolbar className="ltr:pl-16 rtl:pr-16 ltr:pr-8 rtl:pl-8">
            <Typography
              variant="subtitle1"
              className={clsx(classes.cardTitle, 'flex-1')}
            >
              {startText}
            </Typography>
            {endView}
          </Toolbar>
        </AppBar>
        <CardContent {...CardContentProps}>{children}</CardContent>
      </Card>
    </div>
  )
}

Panel.propTypes = {
  children: PropTypes.element,
  startText: PropTypes.any,
  endView: PropTypes.any,
  CardContentProps: PropTypes.object,
  AppBarProps: PropTypes.object,
}

export default React.memo(Panel)
